import React from 'react'

export default function IO(props: React.HTMLAttributes<HTMLSpanElement>) {
  return (
    <span {...props} className="font-io">
      IO
    </span>
  )
}
